// Utility function to check if a phone number is a mobile number
export const isMobileNumber = (phone: string): boolean => {
  if (!phone) return false;
  
  // Remove all non-digit characters
  const cleanPhone = phone.replace(/\D/g, '');
  
  // Indian mobile number patterns (10 digits starting with 6,7,8,9 or 11 digits with country code)
  const indianMobilePattern = /^(?:\+91|91)?[6-9]\d{9}$/;
  
  return indianMobilePattern.test(cleanPhone);
};

// Format phone number for display
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  
  const cleanPhone = phone.replace(/\D/g, '');
  
  // If it's an Indian number with country code
  if (cleanPhone.length === 12 && cleanPhone.startsWith('91')) {
    return `+91 ${cleanPhone.slice(2, 7)} ${cleanPhone.slice(7)}`;
  }
  
  // If it's a 10-digit Indian number
  if (cleanPhone.length === 10) {
    return `${cleanPhone.slice(0, 5)} ${cleanPhone.slice(5)}`;
  }
  
  return phone;
};

// Generate WhatsApp URL
export const getWhatsAppUrl = (phone: string, message?: string): string => {
  const cleanPhone = phone.replace(/\D/g, '');
  const formattedPhone = cleanPhone.startsWith('91') ? cleanPhone : `91${cleanPhone}`;
  const encodedMessage = message ? encodeURIComponent(message) : '';
  
  return `https://wa.me/${formattedPhone}${encodedMessage ? `?text=${encodedMessage}` : ''}`;
};

// Generate phone call URL
export const getPhoneCallUrl = (phone: string): string => {
  return `tel:${phone}`;
};